import { c as _c } from "react/compiler-runtime";
import { Detail } from '@/app/[locale]/subtitles/_components/detail';
import { MovieSubtitleFiles } from '@/app/[locale]/subtitles/_components/movie';
import { TVSubtitleFiles } from '@/app/[locale]/subtitles/_components/tv';
export function MediaDetails(t0) {
  const $ = _c(6);
  const {
    id,
    media_type
  } = t0;
  if (media_type === "movie") {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = {
        "--h": "254px"
      };
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] !== id) {
      t2 = <Detail style={t1}><MovieSubtitleFiles id={id} /></Detail>;
      $[1] = id;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  } else {
    if (media_type === "tv") {
      let t1;
      if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
          "--h": "318px"
        };
        $[3] = t1;
      } else {
        t1 = $[3];
      }
      let t2;
      if ($[4] !== id) {
        t2 = <Detail style={t1}><TVSubtitleFiles id={id} /></Detail>;
        $[4] = id;
        $[5] = t2;
      } else {
        t2 = $[5];
      }
      return t2;
    }
  }
  return null;
}